"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Map = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../../../constants");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _MapFactory = require("../../../Maps/MapFactory");
var _CurrentLocationButton = require("../CurrentLocationButton");
var _ZoomButtons = require("../ZoomButtons");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-no-bind -- x */

const Map = ({
  onMapClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    mapLocation: {
      currentLocation,
      locatePositionInMap,
      onMapInitialization
    },
    pickupPointsMapProps: {
      activeFilter,
      instantSearchTerm,
      isMapVisible,
      selectedMapPickupPoint: selectedPickupPoint,
      setSelectedMapPickupPoint
    },
    togglePickupPointsDialog
  } = (0, _contexts.useMap)();
  const {
    mapConfiguration
  } = (0, _hooks.usePickupPointsSearchConfiguration)();
  const {
    isMapInfoOpen,
    setIsMapInfoOpen,
    setSelectedPickupPointId
  } = (0, _contexts.usePickupPoints)();
  const onPickupPointItemSelection = (0, _react.useCallback)(item => {
    setSelectedMapPickupPoint(item);
    if (item?.coordinates) {
      setSelectedPickupPointId(item.deliveryChannelId);
      locatePositionInMap(item.coordinates, _models.MapLocationType.PickupPoint);
    }
  }, [locatePositionInMap, setSelectedMapPickupPoint, setSelectedPickupPointId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_models.TestId.SelectPickupPointDialogMap),
    onClick: onMapClick,
    onTouchStart: onMapClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MapFactory.MapFactory, {
      ...mapConfiguration,
      activeFilter: activeFilter,
      currentLocation: currentLocation,
      instantSearchTerm: instantSearchTerm,
      isMapVisible: isMapVisible,
      selectedPickupPoint: selectedPickupPoint,
      onMapInitialization: onMapInitialization,
      onPickupPointItemSelection: onPickupPointItemSelection
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CloseButton, {
      variant: "contained",
      color: "default",
      onClick: togglePickupPointsDialog,
      children: formatMessage('close')
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.IconButtons, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ZoomButtons.ZoomButtons, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentLocationButton.CurrentLocationButton, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackNotification, {
      slots: {
        backdrop: undefined
      },
      slotProps: {
        root: {
          style: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }
        }
      },
      open: isMapInfoOpen,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.InfoCircle, {}),
      timeoutMs: _constants.MAP_INFO_FADE_TIMEOUT,
      onClose: () => setIsMapInfoOpen(false),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        "data-testid": getTestId(_models.TestId.MapPreviewUnavailableNotification),
        children: formatMessage('mapPreviewUnavailable')
      })
    })]
  });
};
exports.Map = Map;